export default {
	project_title: 'Jin Tian Cloud',
	master_menu: { //左边主菜单
		menu1: 'Buy/Renew',
		menu2: 'My Phones',
		menu3: 'My Orders',
		menu4: 'Cloud Storage',
		menu5: 'Auto operate',
		menu6: 'Agency',
		menu7: 'Apply Agent',
		menu8: 'Buy Activation Code',
		menu9: 'Conversion Activation Code'
	},
	title_text: {
		cloud_disk_menu_title: 'My File',
		cloud_disk_dialog_title: 'File Rechristen',
		Account_Management_title: 'Account Management',
		Automatically_Publish_videos_title: 'Automatically Publish Videos',
		Look_Task_title: 'Look Task',
		Material_Center_title: 'Material Center'
	},
	button: {
		login: 'Login',
		login_out: 'Login Out',
		register: 'Register',
		delete_btn: 'Delete',
		rechristen: 'Rechristen',
		download: 'Download',
		Upload_files_to_cloud: 'Upload Files To Cloud',
		transfer_cloud: 'Transfer Cloud',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	check_text: {
		check_all: 'Check All',
		insert_filename: 'Insert Filename',
		insert_serial: 'Insert Serial',
	},
	cloud_disk_menu: {
		all: 'all',
		apk: 'apk',
		picture: 'Picture',
		video: 'Video',
		file: 'File'
	},
	other_text: {
		cloud_storage_space: 'Cloud Storage Space',
		have_already_used: 'Have Already Used',
		expand_storage_space: 'Expand Storage Space',
		edit_file_name: 'Edit File Name',
	}
	// 更多翻译...
}